import { TimeCache } from '@1inch-community/core/cache';
import { averageBlockTime } from './average-block-time';
export class BlockTimeCache {
    constructor() {
        this.timeCacheStorage = {};
    }
    set(chainId, key, value) {
        let cache = this.timeCacheStorage[chainId];
        if (!cache) {
            cache = new TimeCache(averageBlockTime[chainId]);
            this.timeCacheStorage[chainId] = cache;
        }
        cache.set(key, value);
    }
    get(chainId, key) {
        const cache = this.timeCacheStorage[chainId];
        if (!cache) {
            return null;
        }
        return cache.get(key);
    }
}
//# sourceMappingURL=block-time-cache.js.map